import {
  Environment,
  devAgoraAppId,
  mapTilerKey,
  stagingApiUrl,
  stagingWsDomain,
  prodFirebaseConfig,
  prodFirebaseVapidKey,
  prodFirebaseTokenId,
  stagingFacebookConfigId,
  devKlipyApiKey,
} from ".";

export const environment: Environment = {
  env: "staging",
  production: false,
  firebaseConfig: prodFirebaseConfig,
  firebaseVapidKey: prodFirebaseVapidKey,
  sentryDsn:
    "https://129221559daee187358a59380af2b2a1@o1211156.ingest.us.sentry.io/4506969796378624",
  sentryWhitelistHosts: [
    "staging.jugl.com",
    /jugl-staging-org-web-rc-\d+-\d+-\d+.netlify.app/g,
  ],
  posthogApiKey: "phc_xBX75uEtVnHb7dDrf9gryebawZaC8NV7RqpL8bC4hAhg",
  // PostHog runs in production only — no capture or replay outside prod/beta
  posthogWhitelistHosts: [],
  apiUrl: stagingApiUrl,
  wsDomain: stagingWsDomain,
  firebaseTokenId: prodFirebaseTokenId,
  mapTilerKey,
  geocodingKey: atob("QUl6YVN5RFFBMGRkUEl1MGEwcG83U3J5eVRRS3NGMWFaQ1lpMHk4"),
  agoraAppId: devAgoraAppId,
  klipyApiKey: devKlipyApiKey,
  chatBotToken:
    "9BqDM5iVLw5u8mLJIztw.zu8dg5RWnZ5NZgihrxAtBixmXBOwZi7BmM2G9rD2UXvqyA35kEOip0pXjTjgvtKoA==",
  isReCaptchaEnabled: true,
  reCaptchaKey: "6LdMnvopAAAAAID5SLUbjhOfVLc2BDzMlvJPr3nn",
  guestUrl: "https://guest-staging.jugl.com",
  facebookConfigId: stagingFacebookConfigId,
  featureFlags: {
    maxChatAttachmentsCount: 10,
    isGmailAuthEnabled: false,
  },
  demoToken: "",
  instagramClientId: "1208905981101498",
  // TODO(shopify-billing): real staging client_id from the Shopify Partner dashboard
  shopifyClientId: "3b17d81b51b83bc1a5b78ad9f50a5982",
  chatBotUrl: "https://jugl-chat-bot-staging.netlify.app",
  liveChatUrl: "https://jugl-live-chat-staging.netlify.app",
  escapeChatChars: true,
};
